<template>
  <div class="navigation-buttons d-flex justify-content-center gap-3 mt-4 mb-3">
    <button
      class="btn btn-secondary"
      @click="handleBack"
      :disabled="isFirstStep"
    >
      <i class="bi bi-chevron-left"></i>
    </button>
    <button class="btn btn-primary" @click="handleNext" :disabled="isLastStep">
      <i class="bi bi-chevron-right"></i>
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "StepNavigationButtons",
  props: {
    isFirstStep: {
      type: Boolean,
      default: false,
    },
    isLastStep: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { t } = useI18n();

    const handleNext = () => {
      const event = new CustomEvent("changeStep", {
        detail: { direction: "next" },
      });
      window.dispatchEvent(event);
    };

    const handleBack = () => {
      const event = new CustomEvent("changeStep", {
        detail: { direction: "back" },
      });
      window.dispatchEvent(event);
    };

    return {
      handleNext,
      handleBack,
      t,
    };
  },
});
</script>

<style scoped>
.navigation-buttons {
  position: sticky;
  bottom: 0;
  background-color: var(--color-white);
  padding: 1rem 0;
}

.btn {
  width: 40px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  background-color: var(--color-white);
  border: 1px solid var(--color-light-gray);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  border-radius: 2px;
}

.btn i {
  font-size: 1.2rem;
  color: var(--color-dark);
}

.btn-primary {
  background-color: var(--color-white);
  border-color: var(--color-light-gray);
}

.btn-primary:hover:not(:disabled) {
  background-color: var(--color-white);
  border-color: var(--primary-color);
  box-shadow: 0 4px 8px rgba(75, 145, 241, 0.2);
}

.btn-primary:hover:not(:disabled) i {
  color: var(--primary-color);
}

.btn-secondary {
  background-color: var(--color-white);
  border-color: var(--color-light-gray);
}

.btn-secondary:hover:not(:disabled) {
  background-color: var(--color-white);
  border-color: var(--primary-color);
  box-shadow: 0 4px 8px rgba(75, 145, 241, 0.2);
}

.btn-secondary:hover:not(:disabled) i {
  color: var(--primary-color);
}

.btn:disabled {
  background-color: var(--color-white);
  border-color: var(--color-light-gray);
  opacity: 0.5;
  box-shadow: none;
}

.btn:disabled i {
  color: var(--color-gray);
}
</style>
